import React, { useState, useEffect, useCallback, useRef } from "react";
import { Tooltip, Button, Popover, Image, Spin, Switch } from "antd";
import { runNavigationGuard } from "../../utils/navigationGuard";
import LocoNexaLogo from "../../assets/LocoNexa-AI.svg";
import cmoverse from "../../assets/cmovers-logo.svg";
import cmoverseNew from "../../assets/final-logo.svg";
import blackHamburgerMenuIcon from "../../assets/ChatWithData/black_hamburger_menu_icon.svg";
import whiteHamburgerMenuIcon from "../../assets/ChatWithData/white_hamburger_menu_icon.svg";
import defaultProfileImage from "../../assets/default_profile_img.png";
import profileIcon from "../../assets/my_profile_icon.svg";
import logoutIcon from "../../assets/logout_icon.svg";
import unlimitedCreditCountIcon from "../../assets/ChatWithData/unlimited_credit_count_icon.svg";
import redCreditCountIcon from "../../assets/ChatWithData/red_credit_count_icon.svg";
import yellowCreditCountIcon from "../../assets/ChatWithData/yellow_credit_count_icon.svg";
import creditsNewIcon from "../../assets/ChatWithData/coin-image.png";
import blueReferalIcon from "../../assets/ChatWithData/blue_referal_icon.svg";
import profileproIcon from "../../assets/ChatWithData/profile_pro_icon.svg";
import profileErrorIcon from "../../assets/ChatWithData/profile_error_icon.svg";
import locationIcon from "../../assets/ChatWithData/Location_icon.svg";
import globeIcon from "../../assets/ChatWithData/Global_Icon.svg";
import closeIcon from "../../assets/ChatWithData/Close-Icon.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  setBrandsInChatWithData,
  setChatsAnswerLoader,
  setChatsStreamLoader,
  setChattopicsHistory,
  setChatWithDataResponse,
  setDurationInChatWithData,
  setOtpStatusFlag,
  setSelectedChatData,
  setSignInThroughFlag,
  setUserProfileModalFlag,
  showBlurredBackground,
  setSSEStreaming,
} from "../../redux/actions/ChatWithData/ChatWithData";
import {
  checkEmailValidityAPI,
  getStarterQuestionsAPI,
  getTopicChatsAPI,
  handleSessionExpiration,
  setLogoutUserAPI,
  setSendReferenceAPI,
} from "../../redux/actions/ChatWithData/ChatWithDataApi";
import { useNavigate } from "react-router-dom";
import SideBar from "./SideBar";
import ProfileModal from "./ProfileModal";
import CustomModal from "./CustomModal";
import blueAiStar from "../../assets/blue_ai_star.svg";
import { LoadingOutlined } from "@ant-design/icons";
import { classOfBadgeType, updatedCountriesList } from "../../redux/constants";
import { trackEvent } from "../utils/posthog";

const Navbar = ({
  isShowSidebar,
  setIsShowSidebar,
  isShowChatHistorySidebar,
  setIsShowChatHistorySidebar,
  text,
  setText,
  share_id,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const authParams = useSelector((state) => state?.Authentication?.authParams);
  const brands = useSelector(
    (state) => state?.ApiCall?.brands?.data?.result?.brands
  );
  const brandlogicalgroup = useSelector(
    (state) => state?.ApiCall?.brandlogicalgroup?.data?.result
  );
  const competitorBrands = useSelector(
    (state) => state?.WidgetAPI?.competitorBrands?.data?.result
  );
  const temporary_words = useSelector(
    (state) => state?.attributes?.temporary_words
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const chatWithDataRes = useSelector(
    (state) => state?.ChatWithData?.chat_with_data_res
  );
  const chatWithData = useSelector((state) => state?.ChatWithData);
  const starterQuestionsList = useSelector(
    (state) => state?.ChatWithData?.starter_questions
  );
  const chatTopicsHistory = useSelector(
    (state) => state?.ChatWithData?.chat_topics_history
  );
  const starterQuestionsLoader = useSelector(
    (state) => state?.ChatWithData?.starter_questions_loader
  );
  const topicAnswerLoader = useSelector(
    (state) => state?.ChatWithData?.topic_answer_loader
  );
  const chatsAnswerLoader = useSelector(
    (state) => state?.ChatWithData?.chats_answer_loader
  );
  const userProfileDetails = useSelector(
    (state) => state?.ChatWithData?.user_profile_details
  );
  const userProfileModalFlag = useSelector(
    (state) => state?.ChatWithData?.user_profile_modal_flag
  );
  const creditsCountLoader = useSelector(
    (state) => state?.ChatWithData?.credits_count_loader
  );
  const getVisitorIdLoader = useSelector(
    (state) => state?.ChatWithData?.get_visitor_id_loader
  );
  const creditLimitExhausted = useSelector(
    (state) => state?.ChatWithData?.credit_limit_exhausted
  );

  const user_credit_count = localStorage.getItem("credit_count");
  const is_subscription_active = localStorage.getItem("is_subscription_active");

  let ip_address = localStorage.getItem("ipAddress");
  let visitor_id = localStorage.getItem("visitor_id");
  let p_token = localStorage.getItem("p_token");
  let is_locobuzz_user = localStorage.getItem("is_locobuzz_user");

  // const [text, setText] = useState("");
  const [searchText, setSearchText] = useState();
  const containerRef = useRef(null);
  const catMenu = useRef(null);
  const [region, setRegion] = useState(() => {
    const storedRegion = localStorage.getItem("Region");
    if (storedRegion === null) {
      localStorage.setItem("Region", JSON.stringify(true));
      return true;
    }
    return storedRegion ? JSON.parse(storedRegion) : true;
  });
  const [showRegionPopup, setShowRegionPopup] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const [showNavbar, setShowNavbar] = React.useState(false);
  const [scrollPosition, setScrollPosition] = useState(null);
  const [emailTags, setEmailTags] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [desktopOpen, setDesktopOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [invalidEmail, setInvalidEmail] = useState("");
  const [profilePopUpDesktop, setProfilePopUpDesktop] = useState(false);
  const [profilePopUpMobile, setProfilePopUpMobile] = useState(false);
  const [showCustomModal, setShowCustomModal] = useState({
    flag: false,
    title: null,
    sub_title: null,
    option: null,
  });
  const [searchModalEnabled, setSearchModalEnabled] = useState(false);
  let badgeClass = classOfBadgeType(
    userProfileDetails?.payment_info?.payment_status
  );
  let countryName = localStorage.getItem("country_name");
  let selectedCountry = localStorage.getItem("selectedCountry");
  let countryCode = localStorage.getItem("country_code");

  // Get country flag from user's region in profile details
  const getCountryFlag = () => {
    const userRegion = userProfileDetails?.profile_info?.region;
    if (userRegion) {
      const country = updatedCountriesList.find(
        (c) => c.code.toUpperCase() === userRegion.toUpperCase()
      );
      if (country) return country.flag;
    }
    // Fallback to country code from localStorage
    if (countryCode) {
      const country = updatedCountriesList.find(
        (c) => c.code.toUpperCase() === countryCode.toUpperCase()
      );
      if (country) return country.flag;
    }
    return null;
  };

  const countryFlag = getCountryFlag();

  useEffect(() => {
    if (!p_token && window.location.pathname === "/chat-with-data") {
      handleSessionExpiration();
    }
  }, [window.location.pathname, p_token]);

  useEffect(() => {
    // only for loggen in users
    if (creditLimitExhausted && p_token) {
      setShowCustomModal({
        flag: true,
        title: "Out of chat credits",
        sub_title: p_token
          ? "It looks like you’ve used up your free credits. To continue chatting, please upgrade your plan."
          : "It looks like you’ve used up your free credits. To continue chatting, please sign up.",
        option: "credit_limit_exhausted",
      });

      setProfilePopUpMobile(false);
      setProfilePopUpDesktop(false);
    }
  }, [creditLimitExhausted]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (catMenu.current && !catMenu.current.contains(event.target)) {
        if (showNavbar) {
          setShowNavbar(false);
        }
      }
    }
    // Bind
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // dispose
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [catMenu, showNavbar]);

  const handleCreateNewChat = () => {
    setText("");
    // Reset State response history
    let obj = {
      persist_data: [],
      data: [],
      total_length: null,
    };
    dispatch(setChatWithDataResponse(obj));

    // Reset selected chat data
    dispatch(setSelectedChatData(null));
  };

  const toggleSidebar = useCallback(() => {
    setIsShowSidebar((prev) => !prev);
  }, []);

  const handleFreeCredits = () => {
    alert("Get Free Credits");
  };

  const handleUserProfile = () => {
    alert("Open Profile");
  };

  const handleSubscribeLocobuzz = () => {
    navigate("/pricing");
  };

  const handleUpgradePlan = () => {
    navigate("/pricing");
  };

  const handleLandingPage = () => {
    const destination = p_token ? "/chat-with-data" : "/";

    // All navigation + teardown lives here. Wrapped so a page with unsaved
    // changes (Edit Profile) can intercept and run this LATER on "Discard" —
    // running the SAME cleanup as a direct click, never a bare navigate().
    const proceed = () => {
      window.stop();

      // Clear any active SSE streaming states before navigation
      if (chatWithDataRes?.data?.length) {
        chatWithDataRes.data.forEach((chat) => {
          if (chat.is_sse_streaming || chat.is_streaming || chat.loader) {
            dispatch(setSSEStreaming(false, chat.query_id));
          }
        });
      }

      // window.location.reload();
      let updatedHistoryList = chatTopicsHistory?.data;
      if (updatedHistoryList?.length) {
        let todayPresent = updatedHistoryList?.filter((d) => d?.name === "Today");
        if (todayPresent?.length && todayPresent?.[0]?.name === "Today") {
          if (updatedHistoryList[0].content?.[0]?.session_name === "New chat") {
            updatedHistoryList[0].content.shift();
          }
        }
      }

      let object = {
        ...chatTopicsHistory,
        persist_data: updatedHistoryList,
        data: updatedHistoryList,
      };
      let obj1 = {
        persist_data: [],
        data: [],
        total_length: null,
      };
      dispatch(setChatWithDataResponse(obj1));
      dispatch(setChattopicsHistory(object));
      dispatch(setChatsStreamLoader(false));
      dispatch(setChatsAnswerLoader(false));

      dispatch(showBlurredBackground(false));
      // if (window.location.pathname.startsWith("/share/id")) {
      //   return;
      // }

      navigate(destination);

      dispatch(setOtpStatusFlag(false));

      // Reset Chat Response
      let obj = {
        persist_data: [],
        data: [],
        total_length: null,
      };
      dispatch(setChatWithDataResponse(obj));

      // Reset selected chat data
      dispatch(setSelectedChatData(null));

      // Close Mobile sidebar
      if (showNavbar) {
        setShowNavbar(false);
      }
      dispatch(setSignInThroughFlag(null));
      if (starterQuestionsList?.length === 0 && p_token) {
        let starterObj = {
          p_token: p_token ? p_token : null,
          visitor_id: p_token ? null : visitor_id ? visitor_id : null,
        };
        dispatch(getStarterQuestionsAPI(starterObj));
      }
      localStorage.removeItem("visitor_query_id");
      localStorage.removeItem("question");
      localStorage.removeItem("question_type");
      localStorage.removeItem("show_visited_session");
    };

    // If a page (e.g. Edit Profile) has unsaved changes, let it intercept and
    // show its own warning. It will call proceed() once the user confirms
    // discard, so the teardown above is never skipped.
    if (runNavigationGuard(destination, proceed)) return;

    proceed();
  };

  const handleShowNavbar = () => {
    setShowNavbar(!showNavbar);
  };

  const handleSendInviteReferal = () => {
    // converted into string
    let updatedMails = emailTags?.join();

    let obj = {
      emails: updatedMails,
      p_token: p_token,
    };
    dispatch(setSendReferenceAPI(obj));

    // Clear State
    setEmailTags([]);
    setEmailError("");

    if (desktopOpen) {
      setDesktopOpen(false);
    }
    if (mobileOpen) {
      setMobileOpen(false);
    }
    setInputValue("");
  };
  const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
  const handleValidationReject = (e) => {
    setEmailError("Looks like an invalid email.");
  };
  const handleInputChange = (e) => {
    setInputValue(e);
    setEmailError("");
  };

  const referalContentPopUp = (
    <div className="referal-box-container">
      <h4 className="referal-box-heading">Earn Free Credits with Referrals</h4>
      <p className="referal-box-sub-heading">
        Invite a friend and earn 5 free credits when they join.
      </p>
      <div className="tags-input-container">
        <div className="mb-15 w-100">
          <label className="referal-input-label">Work Email</label>
          <input
            type="email"
            className="referal-email-input"
            placeholder="user@company.com"
            value={inputValue}
            onChange={(e) => handleInputChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && inputValue.trim()) {
                e.preventDefault();
                if (inputValue.match(isValidEmail)) {
                  onTagAdded([...emailTags, inputValue], emailTags, null, inputValue);
                } else {
                  handleValidationReject();
                }
              }
            }}
            disabled={emailTags?.length >= 50}
          />
          
          {/* Display email pills below input */}
          {emailTags?.length > 0 && (
            <div className="email-pills-container">
              {emailTags.map((tag, index) => (
                <span
                  key={index}
                  className={`email-pill ${
                    invalidEmail?.indexOf(tag) >= 0 ? "email-pill-error" : ""
                  }`}
                >
                  {tag}
                  <span
                    className="email-pill-remove"
                    onClick={() => {
                      const newTagList = emailTags.filter((_, i) => i !== index);
                      onTagAdded(newTagList, emailTags, true, tag);
                    }}
                  >
                    ×
                  </span>
                </span>
              ))}
            </div>
          )}
          
          {emailError && (
            <p className="email-error-text">{emailError}</p>
          )}
        </div>
      </div>
      <div className="send_invite_btn_wrapper">
        <Button
          disabled={
            emailTags?.length > 0 && invalidEmail?.length == 0 ? false : true
          }
          onClick={handleSendInviteReferal}
          className="send_invite_btn"
        >
          Invite & Earn
        </Button>
      </div>
    </div>
  );

  const handleOpenChangeDesktop = (newOpen) => {
    setDesktopOpen(newOpen);
  };

  const handleOpenChangeMobile = (newOpen) => {
    setMobileOpen(newOpen);
  };

  const onTagAdded = async (tag, tagsList, remove, removedTag) => {
    if (tag) {
      let emailAddress = tag?.[tag?.length - 1];

      // Block duplicate emails (case-insensitive)
      if (!remove && emailAddress && emailTags.some(e => e.toLowerCase() === emailAddress.toLowerCase())) {
        setEmailError("This email has already been added.");
        setInputValue("");
        return;
      }

      if (emailAddress === "" || emailAddress === null) {
        setEmailError("Enter your email.");
      } else if (emailAddress === undefined && tag?.length === 0) {
        setEmailError("");
        setEmailTags(tag);
        setInputValue("");
        setInvalidEmail(tag);
      } else if (emailAddress && emailAddress.match(isValidEmail)) {
        let payloadObj = {
          p_token: p_token,
          email: emailAddress,
        };
        if (!remove && tag.length >= tagsList.length) {
          let { isValid, message } = await checkEmailValidityAPI(payloadObj);
          setEmailTags(tag);
          setInputValue("");
          if (isValid) {
            setEmailError("");
          } else {
            setEmailError(message);
            if (!invalidEmail.includes(tag[tag.length - 1])) {
              setInvalidEmail((prev) => [...prev, tag[tag.length - 1]]);
            }
          }
        } else {
          setEmailTags(tag);
          setEmailError("");
          setInputValue("");
          if (invalidEmail.includes(removedTag)) {
            let updated = invalidEmail.filter((tag) => tag !== removedTag);
            setInvalidEmail(updated);
          }
        }
      }
      //  else {
      //   setEmailError("Looks like an invalid email.");
      // }
    }
  };

  // Logout Flow
  const handleLogoutUser = () => {
    const p_token = localStorage.getItem("p_token");
    trackEvent("FR_USER_LOGGED_OUT", {});
    setShowCustomModal({
      flag: true,
      title: "Log out?",
      sub_title: "Are you sure you want to log out?",
      option: "log_out",
    });

    setProfilePopUpMobile(false);
    setProfilePopUpDesktop(false);
  };

  // Logout Flow Old
  const handleLogoutUser1 = () => {
    // Close Chat History Sidebar
    setIsShowChatHistorySidebar(false);

    // Close Trending Question Sidebar
    setIsShowSidebar(false);

    // Logout API Call
    let payloadObj = {
      p_token: p_token,
    };
    dispatch(setLogoutUserAPI(payloadObj));

    const keyToKeep = "visitor_uuid";
    const valueToKeep = localStorage.getItem(keyToKeep); // Store the value

    // clear local stoarge
    localStorage.clear();

    if (valueToKeep !== null) {
      localStorage.setItem(keyToKeep, valueToKeep); // Restore the key
    }

    // Redirect to landing page
    navigate("/");
    dispatch(setOtpStatusFlag(false));

    // Reset Chat Response
    let obj = {
      persist_data: [],
      data: [],
      total_length: null,
    };
    dispatch(setChatWithDataResponse(obj));

    // Reset selected chat data
    dispatch(setSelectedChatData(null));

    // Close Mobile sidebar
    if (showNavbar) {
      setShowNavbar(false);
    }
  };
  // Enable User Profile
  const handleMyProfile = () => {
    // dispatch(setUserProfileModalFlag(true));

    // Redirect to landing page
    navigate("/profile");

    setProfilePopUpMobile(false);
    setProfilePopUpDesktop(false);
  };
  const profileContentPopUp = (
    <div className="profile-box-container">
      <div onClick={handleMyProfile} className="my_profile_btn">
        <img
          src={profileIcon}
          height="20px"
          style={{ marginRight: "5px" }}
          alt="profileIcon"
        />{" "}
        My Profile
      </div>
      <div className="my_profile_btn_divider"></div>
      <div onClick={handleLogoutUser} className="user_logout_btn">
        <img
          src={logoutIcon}
          height="20px"
          style={{ marginRight: "5px" }}
          alt="logoutIcon"
        />{" "}
        Log Out
      </div>
    </div>
  );

  const handleProfilePopUpDesktop = (newOpen) => {
    setProfilePopUpDesktop(newOpen);
  };
  const handleProfilePopUpMobile = (newOpen) => {
    setProfilePopUpMobile(newOpen);
  };

  // Them code
  // const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
  const [theme, setTheme] = useState("dark");
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("app_theme", theme);
  }, [theme]);

  const handleThemeMode = () => {
    setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
  };

  const handleSignUp = () => {
    if (share_id) {
      navigate(`/sign-up/share/${share_id}`);
    } else {
      navigate("/sign-up");
    }
  };
  const handleSignIn = () => {
    navigate("/sign-in");
  };
  const handleFreeChat = () => {
    navigate("/chat-with-data");
  };

  const handleRegionToggle = (value) => {
    setRegion(value);
    localStorage.setItem("Region", JSON.stringify(value));
  };

  const handleRegionChange = (value) => {
    setRegion(value);
    localStorage.setItem("Region", JSON.stringify(value));
    setShowRegionPopup(false);
  };

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobileView(window.innerWidth < 920);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  return (
    <nav
      className={
        window.location.pathname === "/" ? "gradient-navbar1" : "navbar1"
      }
      ref={catMenu}
    >
      <div className="container1">
        <div className="menu-icon">
          {p_token &&
          (window.location.pathname === "/chat-with-data" ||
            window.location.pathname?.startsWith("/share/id")) ? (
            <img
              className="navbar-hamburger-image"
              src={whiteHamburgerMenuIcon}
              onClick={handleShowNavbar}
              alt="hamburgerMenuIcon"
              style={{ marginRight: "10px" }}
            />
          ) : (
            ""
          )}
          {/* For Mobile Navbar Logo */}
          <img
            className="navbar-nexalogo"
            src={cmoverseNew}
            // height="75px"
            // width="75px"
            onClick={handleLandingPage}
            alt="Mobile CMO verse Logo"
          />
        </div>
        <div className="navbar-desktop-logo">
          <img
            src={cmoverseNew}
            style={{
              marginLeft: "25px",
              cursor: "pointer",
            }}
            height="28px"
            onClick={handleLandingPage}
            alt="CMO verse Logo"
          />
        </div>
        <div className="mobile-navbar-content-component">
          {(window.location.pathname === "/chat-with-data" ||
            window.location.pathname?.startsWith("/share/id") ||
            window.location.pathname === "/profile") && (
            <div style={{ display: "flex" }}>
              {/* {!p_token && window.location.pathname === "/chat-with-data" ? (
                <span style={{ marginRight: "10px" }}>
                  <Button className="sign-up_btn" onClick={handleSignUp}>
                    Sign Up
                  </Button>
                </span>
              ) : (
                ""
              )} */}
              {isMobileView &&
                (window.location.pathname === "/chat-with-data" ||
                  window.location.pathname === "/profile") && (
                  <div className="mobile_region_toggle_container">
                    <button
                      className="mobile_region_button"
                      onClick={() => setShowRegionPopup(true)}
                    >
                      {region ? (
                        <>
                          {countryFlag ? (
                            <img
                              className="country-flag-icon-mobile"
                              src={countryFlag}
                              alt="Country Flag"
                            />
                          ) : (
                            <img
                              className="toggle-icon"
                              src={locationIcon}
                              alt="Location"
                            />
                          )}
                          {selectedCountry ? selectedCountry : countryName}
                        </>
                      ) : (
                        <>
                          <img
                            className="toggle-icon"
                            src={globeIcon}
                            alt="Globe"
                          />
                          Global
                        </>
                      )}
                    </button>

                    {showRegionPopup && (
                      <div
                        className="region_popup_overlay"
                        onClick={() => setShowRegionPopup(false)}
                      >
                        <div
                          className="region_popup_content"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <h3 className="popup_title">Select Country</h3>{" "}
                          <Button
                            className="popup_close_button"
                            onClick={() => setShowRegionPopup(false)}
                          >
                            <img className src={closeIcon} alt="Close" />
                          </Button>
                          <div
                            className={`popup_option ${
                              region ? "selected_option" : ""
                            }`}
                            onClick={() => handleRegionChange(true)}
                          >
                            <span className="popup_radio_indicator"></span>{" "}
                            {countryName}
                          </div>
                          <div
                            className={`popup_option ${
                              !region ? "selected_option" : ""
                            }`}
                            onClick={() => handleRegionChange(false)}
                          >
                            <span className="popup_radio_indicator"></span>{" "}
                            Global
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              <span>
                <div
                  className={`${
                    user_credit_count === 0
                      ? "red_question_left_btn"
                      : "question_left_btn"
                  }`}
                >
                  {/* For Mobile Credits Count */}
                  {p_token ? (
                    creditsCountLoader ? (
                      <Spin
                        className="dynamic_loader_spinner1"
                        indicator={
                          <LoadingOutlined
                            style={{
                              fontSize: 20,
                              color: "grey",
                            }}
                            spin
                          />
                        }
                      />
                    ) : is_subscription_active === "true" ? (
                      <Tooltip title="Unlimited Chats">
                        <img
                          style={{ height: "23px", marginRight: "10px" }}
                          src={unlimitedCreditCountIcon}
                          alt="unlimitedCreditCountIcon"
                        />
                      </Tooltip>
                    ) : (
                      <>
                        <img
                          style={{ marginRight: "10px" }}
                          src={
                            user_credit_count === 0 || user_credit_count === "0"
                              ? redCreditCountIcon
                              : yellowCreditCountIcon
                          }
                          alt="yellowCreditCountIcon"
                        />
                        {user_credit_count >= 0 ? (
                          <span
                            style={{
                              color:
                                user_credit_count === 0 ||
                                user_credit_count === "0"
                                  ? "#EA2424"
                                  : "#F1B315",
                            }}
                          >
                            {user_credit_count}
                          </span>
                        ) : (
                          <span
                            style={{
                              color:
                                user_credit_count === 0 ||
                                user_credit_count === "0"
                                  ? "#EA2424"
                                  : "#F1B315",
                            }}
                          >
                            0
                          </span>
                        )}{" "}
                      </>
                    )
                  ) : (
                    ""
                  )}
                  {/* For Mobile Referral */}
                  {(!is_subscription_active ||
                    is_subscription_active === "false") &&
                    p_token &&
                    (window.location.pathname === "/chat-with-data" ||
                      window.location.pathname?.startsWith("/share/id") ||
                      window.location.pathname === "/profile") && (
                      <span
                        style={{
                          marginLeft: "10px",
                          marginTop: "10px",
                        }}
                      >
                        <Popover
                          content={referalContentPopUp}
                          title=""
                          trigger="click"
                          open={mobileOpen}
                          onOpenChange={handleOpenChangeMobile}
                        >
                          <img
                            style={{ marginRight: "10px", height: "25px" }}
                            src={blueReferalIcon}
                            alt="blueReferalIcon"
                          />
                        </Popover>
                      </span>
                    )}
                  {/* For Mobile Profile Icon - Hidden on chat-with-data, shown in sidebar instead */}
                  {p_token &&
                    window.location.pathname !== "/chat-with-data" &&
                    window.location.pathname !== "/profile" &&
                    !window.location.pathname.startsWith("/share/id") && (
                      <span>
                        <Popover
                          overlayStyle={{
                            width: "100vw",
                          }}
                          className="profile-box-main-container"
                          content={profileContentPopUp}
                          title=""
                          trigger="click"
                          open={
                            showCustomModal?.flag ? false : profilePopUpMobile
                          }
                          onOpenChange={handleProfilePopUpMobile}
                        >
                          <img
                            className="profile_image_btn"
                            style={{ height: "25px" }}
                            src={
                              userProfileDetails?.profile_info?.profile_pic
                                ? userProfileDetails?.profile_info?.profile_pic
                                : defaultProfileImage
                            }
                            alt="profile"
                          />
                          {(badgeClass || is_subscription_active === "true") ? (
                            <img
                              className={badgeClass || "pro-image"}
                              src={
                                badgeClass === "error-icon"
                                  ? profileErrorIcon
                                  : profileproIcon
                              }
                              alt="profile_image_btn"
                              fallback={defaultProfileImage}
                              preview={false}
                              width={"25px"}
                            />
                          ) : (
                            ""
                          )}
                        </Popover>
                      </span>
                    )}
                </div>
              </span>
              {!p_token &&
              (window.location.pathname === "/chat-with-data" ||
                window.location.pathname?.startsWith("/share/id") ||
                window.location.pathname === "/profile") ? (
                <span style={{ marginRight: "10px" }}>
                  <Button className="sign-up_btn" onClick={handleSignUp}>
                    Sign Up
                  </Button>
                </span>
              ) : (
                ""
              )}
            </div>
          )}
          <div style={{ display: "flex" }}>
            {window.location.pathname === "/" ? (
              <Button
                style={{
                  pointerEvents: getVisitorIdLoader ? "none" : "auto",
                }}
                className="start-free-chat_btn"
                onClick={handleFreeChat}
              >
                {p_token ? "Start chat" : "Start free chat"}
              </Button>
            ) : (
              ""
            )}
            {!p_token && window.location.pathname === "/" ? (
              <>
                {/* <Button className="sign-in_btn" onClick={handleSignIn}>
                  Sign In
                </Button> */}
                <Button className="sign-up_btn" onClick={handleSignUp}>
                  Sign Up
                </Button>
              </>
            ) : (
              ""
            )}
          </div>
        </div>

        <div
          style={{ display: !isMobileView ? "flex" : "" }}
          className={`nav-elements  ${showNavbar && "active"}`}
        >
          {!isMobileView &&
          p_token &&
          (window.location.pathname === "/chat-with-data" ||
            window.location.pathname === "/profile") ? (
            <div
              className="region_toggle_container"
              style={isMobileView ? { display: "none" } : {}}
            >
              <div
                className={
                  region ? "region_btn_selected" : "region_btn_non_selected"
                }
                onClick={() => handleRegionToggle(true)}
                style={{ width: "auto", padding: "0 1rem" }}
              >
                {countryFlag ? (
                  <img
                    className="country-flag-icon"
                    src={countryFlag}
                    alt="Country Flag"
                  />
                ) : (
                  <img
                    className={`toggle-icon ${region ? "visible" : "hidden"}`}
                    src={locationIcon}
                    alt="Location"
                  />
                )}
                {selectedCountry ? selectedCountry : countryName}
              </div>

              <div
                className={
                  !region ? "region_btn_selected" : "region_btn_non_selected"
                }
                onClick={() => handleRegionToggle(false)}
                style={{ width: "auto", padding: "0 1.2rem" }}
              >
                <img
                  className="toggle-icon"
                  src={globeIcon}
                  alt="Globe"
                />
                Global
              </div>
            </div>
          ) : (
            ""
          )}
          {/* Desktop component */}
          <div className="desktop-navbar-content-component">
            {(window.location.pathname === "/chat-with-data" ||
              window.location.pathname?.startsWith("/share/id") ||
              window.location.pathname === "/profile") && (
              <>
                {p_token ? (
                  creditsCountLoader ? (
                    <Spin
                      className="dynamic_loader_spinner1"
                      indicator={
                        <LoadingOutlined
                          style={{
                            fontSize: 20,
                            color: "grey",
                          }}
                          spin
                        />
                      }
                    />
                  ) : is_subscription_active === "true" ? (
                    <Tooltip title="Unlimited Chats">
                      <img
                        style={{ height: "33px" }}
                        src={unlimitedCreditCountIcon}
                        alt="unlimitedCreditCountIcon"
                      />
                    </Tooltip>
                  ) : (
                    <div className="credits-earn-container">
                      <div className={`credits-display ${user_credit_count === 0 || user_credit_count === "0" ? "credits-empty" : ""}`}>
                        <img
                          className="credits-coin-icon"
                          src={creditsNewIcon}
                          alt="Credits"
                        />
                        <span className="credits-count">
                          {user_credit_count >= 0 ? user_credit_count : 0}
                        </span>
                        <span className="credits-label">Credits</span>
                      </div>
                      <Popover
                        content={referalContentPopUp}
                        title=""
                        trigger="click"
                        open={desktopOpen}
                        onOpenChange={handleOpenChangeDesktop}
                      >
                        <div className="earn-more-btn">
                          Earn More
                        </div>
                      </Popover>
                    </div>
                  )
                ) : (
                  ""
                )}
                {!p_token &&
                (window.location.pathname === "/chat-with-data" ||
                  window.location.pathname.startsWith("/share/id")) ? (
                  <>
                    <Button
                      style={{ marginLeft: "15px", marginRight: "-15px" }}
                      className="sign-up_btn"
                      onClick={handleSignUp}
                    >
                      Sign Up
                    </Button>
                  </>
                ) : (
                  ""
                )}


              </>
            )}

            {/* Desktop Profile Icon - Hidden on landing page and chat-with-data and profile, shown in sidebar instead */}
            {p_token &&
              window.location.pathname !== "/" &&
              window.location.pathname !== "/chat-with-data" &&
              window.location.pathname !== "/profile" &&
              !window.location.pathname.startsWith("/share/id") && (
                <span className="navbar-profile-wrapper">
                  <Popover
                    overlayStyle={{
                      width: "18vw",
                    }}
                    className="profile-box-main-container"
                    content={profileContentPopUp}
                    title=""
                    trigger="click"
                    open={profilePopUpDesktop}
                    onOpenChange={handleProfilePopUpDesktop}
                  >
                    <div className={`navbar-profile-avatar navbar-avatar-${is_locobuzz_user === "true" ? "locobuzz" : is_subscription_active === "true" ? "pro" : "regular"}`}>
                      <Image
                        className="profile_image_btn"
                        src={
                          userProfileDetails?.profile_info?.profile_pic
                            ? userProfileDetails?.profile_info?.profile_pic
                            : defaultProfileImage
                        }
                        alt="profile_image_btn"
                        fallback={defaultProfileImage}
                        preview={false}
                      />
                    </div>
                  </Popover>
                </span>
              )}
            {/* Theme handled  */}
            {/* {window.location.pathname === "/" && (
              <Button
                className="navbar-upgrade-plan-btn"
                onClick={handleThemeMode}
              >
                Mode
              </Button>
            )} */}

            <div style={{ display: "flex" }}>
              {window.location.pathname === "/" ? (
                <Button
                  style={{
                    pointerEvents: getVisitorIdLoader ? "none" : "auto",
                  }}
                  className="start-free-chat_btn"
                  onClick={handleFreeChat}
                >
                  <img className="start-free-chat_btn-img" src={blueAiStar} />
                  {p_token ? "Start chat" : "Start free chat"}
                </Button>
              ) : (
                ""
              )}
              {!p_token && window.location.pathname === "/chat-with-data" ? (
                <>
                  {/* <Button className="sign-up_btn" onClick={handleSignUp}>
                    Sign Up
                  </Button> */}
                </>
              ) : !p_token && window.location.pathname === "/" ? (
                <>
                  {/* commenting unnecessary border  with sign in button on navbar */}
                  {/* <div className="sign-in_btn_divider"></div> */}
                  {/* added signup class for button */}
                  <Button className="sign-up_btn" onClick={handleSignIn}>
                    Sign In
                  </Button>
                  {/* <Button className="sign-up_btn" onClick={handleSignUp}>
                    Sign Up
                  </Button> */}
                </>
              ) : (
                ""
              )}
            </div>
          </div>

          {/* Mobile component */}
          <div
            className="mobile-navbar-content-component"
            style={{ marginTop: "-11px", marginRight: "0px" }}
          >
            <SideBar
              isShowChatHistorySidebar={isShowChatHistorySidebar}
              setIsShowChatHistorySidebar={setIsShowChatHistorySidebar}
              text={text}
              setText={setText}
              showNavbar={showNavbar}
              setShowNavbar={setShowNavbar}
              searchModalEnabled={searchModalEnabled}
              setSearchModalEnabled={setSearchModalEnabled}
            />
          </div>
        </div>
      </div>
      {userProfileModalFlag && (
        <ProfileModal userProfileModalFlag={userProfileModalFlag} />
      )}

      {showCustomModal?.flag ? (
        <CustomModal
          isModalOpen={showCustomModal?.flag}
          setShowCustomModal={setShowCustomModal}
          title={showCustomModal?.title}
          sub_title={showCustomModal?.sub_title}
          option={showCustomModal?.option}
          setIsShowChatHistorySidebar={setIsShowChatHistorySidebar}
          setIsShowSidebar={setIsShowSidebar}
          setShowNavbar={setShowNavbar}
          showNavbar={showNavbar}
        />
      ) : (
        ""
      )}
    </nav>
  );
};

export default Navbar;
